export default __webpack_public_path__ + "static/media/sharp.eaffb5a0.svg";